module.exports = __webpack_public_path__ + "static/bot1000-e01a4aaf3045a44968bff0442118ffe2.png";